export const RegaMapping = [
  {
    key: "advertiser_id",
    label: {
      ar: "رقم هوية المعلن ",
      en: "",
    },
    mapping: "advertiser_id",
  },
  {
    key: "ad_license_number",
    label: {
      ar: "رقم ترخيص الإعلان",
      en: "",
    },
    mapping: "ad_license_number",
  },
  {
    key: "deed_number",
    label: {
      ar: "رقم صك الملكية",
      en: "",
    },
    mapping: "deed_number",
  },
  {
    key: "advertiser_name",
    label: {
      ar: "اسم المعلن",
      en: "",
    },
    mapping: "advertiser_name",
  },
  {
    key: "phone_number",
    label: {
      ar: "رقم التواصل للمعلن",
      en: "",
    },
    mapping: "phone_number",
  },
  {
    key: "brokerage_and_marketing_license_number",
    label: {
      ar: "رقم رخصة فال",
      en: "",
    },
    mapping: "brokerage_and_marketing_license_number",
  },
  {
    key: "channels",
    label: {
      ar: "قنوات الإعلان ",
      en: "",
    },
    mapping: "channels",
  },
  {
    key: "is_constrained",
    label: {
      ar: "وجود قيد؟ ",
      en: "",
    },
    mapping: "is_constrained",
  },
  {
    key: "is_pawned",
    label: {
      ar: "وجود رهن؟",
      en: "",
    },
    mapping: "is_pawned",
  },
  {
    key: "street_width",
    label: {
      ar: "عرض الشارع",
      en: "",
    },
    mapping: "street_width",
  },
  {
    key: "property_area",
    label: {
      ar: "مساحة العقار",
      en: "",
    },
    mapping: "property_area",
  },
  {
    key: "location_region,location_region_code",
    label: {
      en: "",
      ar: "المنطقة/رقم المنطقة",
    },
    join: "/",
    mapping: ["location_region", "location_region_code"],
  },
  {
    key: "location_city,location_city_code",
    label: {
      en: "",
      ar: "المدينة/رقم المدينة",
    },
    join: "/",
    mapping: ["location_city", "location_city_code"],
  },
  {
    key: "location_district,location_district_code",
    label: {
      en: "",
      ar: "الحي/رقم الحي",
    },
    join: "/",
    mapping: ["location_district", "location_district_code"],
  },
  {
    key: "location_street,location_building_number",
    label: {
      en: "",
      ar: "اسم الشارع/رقم المبنى",
    },
    join: "/",
    mapping: ["location_street", "location_building_number"],
  },
  {
    key: "location_latitude,location_longitude",
    label: {
      en: "",
      ar: "خط الطول/خط العرض ",
    },
    join: "/",
    mapping: ["location_latitude", "location_longitude"],
  },
  {
    key: "location_postal_code",
    label: {
      ar: "الرمز البريدي",
      en: "",
    },
    mapping: "location_postal_code",
  },
  {
    key: "location_additional_number",
    label: {
      ar: "الرقم الإضافي",
      en: "",
    },
    mapping: "location_additional_number",
  },
  {
    key: "property_price",
    label: {
      ar: "سعر  الوحدة/سعر المتر للأرض ",
      en: "",
    },
    mapping: "property_price",
  },
  {
    key: "number_of_rooms",
    label: {
      ar: "عدد الغرف",
      en: "",
    },
    mapping: "number_of_rooms",
  },
  {
    key: "property_type",
    label: {
      ar: "نوع العقار",
      en: "",
    },
    mapping: "property_type",
  },
  {
    key: "property_age",
    label: {
      ar: "عمر العقار",
      en: "",
    },
    mapping: "property_age",
  },
  {
    key: "advertisement_type",
    label: {
      ar: "غرض الإعلان",
      en: "",
    },
    mapping: "advertisement_type",
  },
  {
    key: "obligations_on_the_property",
    label: {
      ar: "الالتزامات على العقار",
      en: "",
    },
    mapping: "obligations_on_the_property",
  },
  {
    key: "compliance_with_the_saudi_building_code",
    label: {
      ar: "مطابقة كود البناء السعودي",
      en: "",
    },
    mapping: "compliance_with_the_saudi_building_code",
  },
  {
    key: "guarantees_and_their_duration",
    label: {
      ar: "الضمانات ومدتها ",
      en: "",
    },
    mapping: "guarantees_and_their_duration",
  },
  {
    key: "plan_number",
    label: {
      ar: "رقم المخطط",
      en: "",
    },
    mapping: "plan_number",
  },
  {
    key: "property_face",
    label: {
      ar: "واجهة العقار",
      en: "",
    },
    mapping: "property_face",
  },
  {
    key: "property_usages",
    label: {
      ar: "استخدام العقار",
      en: "",
    },
    mapping: "property_usages",
  },
  {
    key: "property_utilities",
    label: {
      ar: "خدمات العقار",
      en: "",
    },
    mapping: "property_utilities",
  },
  {
    key: "the_borders_and_lengths_of_the_property",
    label: {
      ar: "حدود وأطوال العقار",
      en: "",
    },
    mapping: "the_borders_and_lengths_of_the_property",
  },
  {
    key: "creation_date,end_date",
    label: {
      ar: "مدة ترخيص الإعلان",
      en: "",
    },
    join: " - ",
    mapping: ["creation_date", "end_date"],
  },
];
const a = ["للبيع", "للإيجار"];
export const TestLicenses = [
  ["7200742455", "7008082138", "شقة بيع"],
  ["7200742424", "7051230428", "شقة إيجار"],
  ["7200742445", "7012044140", "عمارة بيع"],
  ["7200742262", "7036218308", "ارض بيع"],
  ["7200742350", "7015370070", "فيلا بيع"],
  ["7200741986", "7037075715", "دور بيع"],
  ["7200741626", "7051015019", "عمارة إيجار"],
  ["7200741622", "7051015019", "برج إيجار"],
  ["7200742492", "7030182146", "فيلا إيجار"],
  ["7200742502", "7034440342", "دور إيجار"],
  ["7200742535", "7001829428", "معرض إيجار"],
  ["7200742385", "7050085914", "شقَّة صغيرة (استوديو) إيجار"],
  ["7200742710", "7021491324", "إستراحة إيجار"],
  ["7200741827", "7010992175", "إستراحة بيع"],
  ["7200741044", "7041572426", "غرفة بيع"],
  ["7200742782", "7034686837", "ارض إيجار"],
  ["7200742794", "7003274979", "غرفة إيجار"],
  ["7200742942", "7042838669", "مكتب إيجار"],
  ["7200741167", "7033214904", "مجمع إيجار"],
  ["7200743115", "7025159331", "مستودع إيجار"],
  ["7200743098", "7001634240", "مزرعة بيع"],
  ["7200743163", "7001965230", "ورشة إيجار"],
];
